import $ from 'jquery';

export class FaqTopics {

	// Single point of update for classNames.
	_activeTopicBtnClassName = 'is-selected'
	_hideTopicFaqClassName = 'hide-topic-faqs'

	// Elements.
	_topicBtns;
	_faqs;

	constructor( topicBtnSelector = 'button[data-faq-topic-index]', faqsSelector = '.qna-list[data-faq-topic-index]' ) {
		this.topicBtns = $( topicBtnSelector );
		this.faqs = $( faqsSelector );

		// No need to add functionality if there is only one topic.
		if ( this.topicBtns.length >= 1 && this.faqs ) {
			this.bindEvents();
		}
	}

	/**
	 * Bind teh on click events for topic buttons, adding and removing classNames as needed.
	 */
	bindEvents() {
		this.topicBtns.on( 'click', ( e ) => this.toggleTopic( e ) );
	}

	toggleTopic( e ) {
		e.preventDefault();
		const $this = $( e.currentTarget );
		const topicIndex = $this.attr( 'data-faq-topic-index' );

		// Update the button className to display the active button.
		const otherTopicBtns = this.topicBtns.not( `[data-faq-topic-index="${ topicIndex }"]` );
		if ( otherTopicBtns.length ) {
			otherTopicBtns.removeClass( this.activeTopicBtnClassName );
			$this.addClass( this.activeTopicBtnClassName );
		}

		if ( topicIndex >= 0 ) {
			// Hide other FAQs.
			const otherFaqs = this.faqs.not( `[data-faq-topic-index="${ topicIndex }"]` );
			if ( otherFaqs.length ) {
				otherFaqs.addClass( this.hideTopicFaqClassName );
				otherFaqs.slideUp( 300 ); // Animate.
			}

			// Show selected FAQs.
			const thisFaqs = this.faqs.filter( `[data-faq-topic-index="${ topicIndex }"]` );
			if ( thisFaqs.length ) {
				thisFaqs.removeClass( this.hideTopicFaqClassName );
				thisFaqs.slideDown( 300 ); // Animate.
			}
		} else {
			// Show all FAQs.
			this.faqs.removeClass( this.hideTopicFaqClassName );
			this.faqs.slideDown( 300 ); // Animate.
		}
	}

	/** ------------------------------------------------------------------------------------------
	 * Setters.
	 * ------------------------------------------------------------------------------------------ */

	set topicBtns( value ) {
		this._topicBtns = value;
	}

	set faqs( value ) {
		this._faqs = value;
	}

	/** ------------------------------------------------------------------------------------------
	 * Getters.
	 * ------------------------------------------------------------------------------------------ */

	get activeTopicBtnClassName() {
		return this._activeTopicBtnClassName;
	}

	get hideTopicFaqClassName() {
		return this._hideTopicFaqClassName;
	}

	get topicBtns() {
		return this._topicBtns;
	}

	get faqs() {
		return this._faqs;
	}
}